import { Component } from "react";
import sendPageView from "../../util/analytics/sendPageView";

// This component only exists to listen to 'history' and send a pageview event to
// Google Analytics. It doesn't actually render anything.
class LogPageView extends Component {
  componentWillUnmount() {
    this.unlisten();
  }

  componentDidMount() {
    this.unlisten = this.props.history.listen((location, action) => {
      sendPageView(location.pathname);
    });
  }

  render() {
    // Not actually rendering anything to the DOM here
    return null;
  }
}

export default LogPageView;



// WEBPACK FOOTER //
// ./src/Shared/LogPageView/LogPageView.js